/**
 * Warstwa API: /itam/teamviewer — WIDOK URZĄDZEŃ, „Dodaj urządzenie” i „Edytuj” (polecenie właściciela 2026-09-28).
 *
 * Trasy backendu (`ItamUrzadzeniaTeamViewerController`, `api/itam/teamviewer-urzadzenia`):
 *  • `GET`                        — widok pogrupowany: grupy, wiersze, liczniki, źródło stanu (klucz odczytu),
 *  • `GET podpowiedzi?osobaId=`   — komputery z ewidencji sprzętu osoby i grupy jej spółek,
 *  • `GET osoby?szukaj=`          — pracownicy do pola „Pracownik” (stanowisko · dział),
 *  • `GET kandydaci?osobaId=`     — propozycje urządzeń dla osoby (szuflada z karty zgłoszenia, 2026-09-30),
 *  • `POST`                       — dodanie w TeamViewerze, potem ewidencja (`Itam:ItamTeamViewerCreate`),
 *  • `PUT`                        — edycja: w TeamViewerze tylko zmienione pola, potem ewidencja (`Itam:ItamTeamViewerEdit`).
 *
 * Odmowa serwera ma kształt `{ message, pole, rodzaj }` — okno stawia zdanie przy polu (`pole`) albo w oknie.
 */
export function attach(api) {
    return {
        getWidokUrzadzenTeamViewer: () => api.get("/itam/teamviewer-urzadzenia"),
        getPodpowiedziUrzadzeniaTeamViewer: (osobaId) =>
            api.get("/itam/teamviewer-urzadzenia/podpowiedzi", { params: { osobaId } }),
        /* [przegląd 2026-09-28, reguła CW 23.09 „wszędzie jedno pole wyboru osoby”] Osoby do okna: nazwisko +
           stanowisko · dział głównego przypisania (fraza od 2 znaków, czynni pracownicy, klucz zapisu modułu). */
        getOsobyUrzadzeniaTeamViewer: (szukaj) =>
            api.get("/itam/teamviewer-urzadzenia/osoby", { params: { szukaj } }),
        /* [polecenie właściciela 2026-09-30] Szuflada „Przypisz komputer TeamViewera” z karty zgłoszenia: osoba, jej
           sprzęt z ITAM, urządzenia już przypisane, PROPOZYCJE z powodem i lekka lista wszystkich do szukajki. */
        getKandydaciUrzadzenTeamViewer: (osobaId) =>
            api.get("/itam/teamviewer-urzadzenia/kandydaci", { params: { osobaId } }),
        dodajUrzadzenieTeamViewer: (dane) => api.post("/itam/teamviewer-urzadzenia", dane),
        edytujUrzadzenieTeamViewer: (dane) => api.put("/itam/teamviewer-urzadzenia", dane),
    };
}
